import Component from './component'
import PropTypes from 'prop-types'
import { routerPropTypes } from 'Types'
import skins from './skins'
import { skin } from 'Utils'

Component.propTypes = {
    className: PropTypes.any,
    theme: PropTypes.any,
    ...routerPropTypes
  }

export default skin(Component, skins)
